/**
 * Copyright (c) samjay.dev.
 *
 * Notes:
 * This source code is the private property of samjay.dev.
 * You cannot modify, share or copy these source codes without any formal authorization,
 * otherwise samjay.dev reserves the right to pursue any legal action.
 *
 * Developer: Sam Tsang (info@samjay.dev)
 */

import React, { useEffect, useState } from 'react';
import TextArea from './TextArea';
import { PostComment } from 'services/blog.sevices';
import { encodeContent } from 'utils';
import { useDispatch } from 'react-redux';
import { Action } from 'store/slices';

const CommentBox: React.FC<{
  aid?: number | string,
  post: (aid: string | number, name: string, email: string, comment: string) => void,
  isLoading: boolean,
  isSuccess: boolean
}> = ({
  aid, post, isLoading, isSuccess
}) => {

    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [comment, setComment] = useState('');

    const postComment = () => {
      if (!aid) return;

      if (!name) {
        dispatch(Action.toggleDialog({toggle: true, type: 'warning', msg: 'Missing - Name!'}))
        return;
      }

      if (!email) {
        dispatch(Action.toggleDialog({toggle: true, type: 'warning', msg: 'Missing - Email!'}))
        return;
      }

      if (!comment) {
        dispatch(Action.toggleDialog({toggle: true, type: 'warning', msg: 'Missing - Comment!'}))
        return;
      }

      post(aid, name, email, encodeContent(comment))
    }

    useEffect(() => {
      if (!isLoading && isSuccess) {
        setName('')
        setEmail('')
        setComment('')
      }
    }, [isLoading])

    return (
      <div>
        <div>
          <input type='text' placeholder='Name' value={name} onChange={(e) => setName(e.target.value)} />
          <input type='email' placeholder='Eamil address' value={email} onChange={(e) => setEmail(e.target.value)} />
        </div>
        <TextArea value={comment} onChange={(_, editor) => setComment(editor.getData())} />
        <div>
          <div onClick={() => postComment()}>Post Comment</div>
          <div>Clear</div>
        </div>
      </div>
    );
  }

export default CommentBox;